export default "__VITE_ASSET__BnTjZ0VQ__"